import apiClient from "../../services/api";

export const getUsers = ({ filter, token }) => {
  let options = {
    params: filter,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return apiClient.get("/users/", options);
};
